import * as React from 'react';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import axios from 'axios';
import authService from './api-authorization/AuthorizeService';

interface LinkJobsModal {
    errors: any;
    loading: boolean;
}

interface AllocateLinkJobsProps {
    showModal: boolean;
    siteAddress: string;
    allocatedJobs: AllocatedJob[];
    hideModal(): void;
    updateSiteAddress(siteAddress: string): void;
    updateData(alloctedJob: AllocatedJob[]): void;
    save(): void;
    saveUnlinkJob(alloctedJob: AllocatedJob[], jobId: string): void;
}

interface AllocatedJob {
    selected: boolean;
    jobId: string;
    siteAddress: string;
    linkedJobId: number;
}

export default class AllocateLinkJobsModal extends React.Component<AllocateLinkJobsProps, LinkJobsModal> {
    constructor(props: AllocateLinkJobsProps) {
        super(props);
        this.state = {
            errors: {},
            loading: false
        }
    }

    handleSiteAddrChange = (e: any) => {
        this.props.updateSiteAddress(e.target.value);
    }

    handlePropsCheckboxChange = (e: any, jobId: string) => {
        let allocatedJobs = this.props.allocatedJobs;
        let jobs = allocatedJobs.filter(j => j.jobId === jobId);
        for (var x = 0; x < jobs.length; x++) {
            jobs[x].selected = e.target.checked;
        }

        this.props.updateData(allocatedJobs);
    }

    unlinkJob = (e: any, jobId: string) => {
        e.preventDefault();

        this.unlinkJobItem(jobId);
    }

    async unlinkJobItem(jobId: string) {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var unlinkJob = {
            jobId: jobId,
            subId: user.sub
        };

        axios.post('api/Allocate/UnlinkJob', unlinkJob, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            //update all items with selected job id to be unlinked
            var allocatedJobs = this.props.allocatedJobs;
            var linkedJobs = allocatedJobs.filter(j => j.jobId == jobId);
            for (var i = 0; i < linkedJobs.length; i++) {
                linkedJobs[i].linkedJobId = 0;
            }

            this.props.saveUnlinkJob(allocatedJobs, unlinkJob.jobId);
            toast.success("Allocation Item/s Unlinked");
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    hideModal = () => {
        this.props.hideModal();
    }

    save = (e: any) => {
        e.preventDefault();

        var selected = this.props.allocatedJobs.filter(a => a.selected);

        if (selected.length < 1) {
            toast.error("You must select at least 2 jobs to link!")
        } else {
            this.props.save();
        }
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();


        return (<div>
            {contents}
        </div>);
    }

    renderDetails = () => {
        var siteAddrFilter = this.props.siteAddress;
        let allocatedJobs = siteAddrFilter.length < 3 ? [] : this.props.allocatedJobs.filter(j => j.siteAddress.toLowerCase().indexOf(siteAddrFilter.toLowerCase()) > -1);

        return (
            <div className="static-modal">
                <Modal size="lg" show={this.props.showModal} onHide={this.hideModal}>
                    <Modal.Header className="modal__header--colour">
                        <Modal.Title>Link Jobs</Modal.Title>
                        <button type="button" className="close" onClick={this.hideModal}>&times;</button>
                    </Modal.Header>
                    <Modal.Body>
                        <div>Select jobs that you want to link together. This will create one runsheet, the total of each item and the unit numbers linked.</div>
                        <div>Notes:</div>
                        <div className="marginLeft10">* Usually you would only link jobs that are split across multiple units with the same address</div>
                        <div className="marginLeft10">* You will need to unlink jobs (and then re-link) in order to add jobs into the link</div>
                        <label className="input-group" htmlFor="siteAddress">
                            <span className="label">Site Address</span>
                            <input type='text' id="siteAddress" name="siteAddress" className='input' value={this.props.siteAddress} onChange={(e) => this.handleSiteAddrChange(e)}></input>
                        </label>
                        <div>
                            <div className='overflowAuto'>
                                <table className='table tableColours'>
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th>Job Id</th>
                                            <th>Site Address</th>
                                            <th>Existing Link</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {allocatedJobs.map((job, index) =>
                                            <tr key={index}>
                                                <td><input type='checkbox' className={job.linkedJobId === 0 ? "input" : "hidden"} checked={job.selected} onChange={(e) => this.handlePropsCheckboxChange(e, job.jobId)} /></td>
                                                <td>{job.jobId}</td>
                                                <td>{job.siteAddress}</td>
                                                <td>{job.linkedJobId === 0 ? "" : job.linkedJobId}</td>
                                                <td>
                                                    <a href="#" className={job.linkedJobId === 0 ? "hidden" : ""} onClick={(e) => this.unlinkJob(e, job.jobId)}>Unlink Job</a>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <button className="popup-button--yes" onClick={this.save}>Save</button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }



}